import http from "./http-common";

class UploadFilesService {
  upload(file, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);

    return http.post("/uploadFile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  uploadImage(files) {
    let formData = new FormData();
    if (files.length != 0) {
      for (const single_file of files) {
        formData.append('files', single_file)
      }
    }
    return http.post("/uploadImage", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }


  getFiles() {
    return http.get("/files");
  }
}

export default new UploadFilesService();